import { createSelector } from 'reselect';

export const selectRaw = (state) => state.product;

export const selectProduct = createSelector(
  [selectRaw],
  (product) => product.product,
);

export const selectProducts = createSelector(
  [selectRaw],
  (product) => product.products,
);

export const selectImages = createSelector(
  [selectRaw],
  (product) => product.images,
);

export const selectIsLoading = createSelector(
  [selectRaw],
  (product) => product.isLoading,
);

export const selectIsUploading = createSelector(
  [selectRaw],
  (product) => product.isUploading,
);

export const selectIsLoadingExport = createSelector(
  [selectRaw],
  (product) => product.isLoadingExport,
);

export const selectErrorMessage = createSelector(
  [selectRaw],
  (product) => product.errorMessage,
);

export const selectHnLPlantCode = createSelector(
  [selectRaw],
  (state) => state?.HnLplantCode,
);

export const selectHnLProduct = createSelector(
  [selectRaw],
  (state) => state?.HnLProducts,
);

const selectors = {
  selectRaw,
  selectProduct,
  selectProducts,
  selectImages,
  selectIsLoading,
  selectIsUploading,
  selectIsLoadingExport,
  selectErrorMessage,
  selectHnLPlantCode,
  selectHnLProduct,
};

export default selectors;
